var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificateView"},[_c('navigation3',{staticClass:"navigation3"}),_c('router-view',{key:_vm.$route.fullPath,staticClass:"router-box"}),_c('footer',{staticClass:"footer"},[_c('FootersPartner')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }